import * as React from 'react';
import { Link } from 'react-router-dom';
import { getStandardNavigationCatalogue } from '@cdf/navigation-catalogue';

const canonicalDestinations = new Set([...getStandardNavigationCatalogue().map(item => item.to).filter(to => !to.includes(':')),
  '/manage/tenders?create=1']);

/** Only canonical links in the server's filtered lifecycle response become navigation controls. */
export function AgentLifecycleReply({ content, disabled, onNavigate }: {
  content: string;
  disabled: boolean;
  onNavigate: (to: string) => void;
}) {
  const parts: React.ReactNode[] = [];
  const pattern = /\[([^\]\n]+)\]\(([^)\s]+)\)/g;
  let offset = 0;
  for (const match of content.matchAll(pattern)) {
    const index = match.index;
    parts.push(content.slice(offset, index));
    const title = match[1]!, to = match[2]!;
    parts.push(canonicalDestinations.has(to) && !disabled
      ? <Link key={index} to={to} className="underline underline-offset-4" onClick={event => {
        event.preventDefault();
        onNavigate(to);
      }}>{title}</Link>
      : <span key={index}>{title}</span>);
    offset = index + match[0].length;
  }
  parts.push(content.slice(offset));
  return <div className="whitespace-pre-wrap">{parts}</div>;
}
